/**
 * @fileoverview Client-safe constants for experiment ledger ingestion.
 * @description Shared between browser beacons and server routes without
 * importing server-only modules (`next/server`, `~/env`, rate limiters).
 *
 * @module lib/experiments/ledger-ingest-client
 */

/** Request header carrying the server-minted HMAC ingest token. */
export const LEDGER_INGEST_TOKEN_HEADER = "x-adsights-ledger-token"

/** DOM id for the server-injected ledger ingest token bootstrap payload. */
export const LEDGER_INGEST_TOKEN_ELEMENT_ID = "adsights-experiment-ledger-token"
